export default __webpack_public_path__ + "static/media/4.002f79c1.webp";